import { useCallback, useState } from 'react';

type TruncatedTooltipEvent = React.MouseEvent<HTMLElement> | React.FocusEvent<HTMLElement>;

export type TruncatedTooltipState = {
  text: string;
  top: number;
  left: number;
};

interface UseTruncatedTooltipOptions {
  targetSelector?: string;
}

export const useTruncatedTooltip = ({ targetSelector }: UseTruncatedTooltipOptions = {}) => {
  const [tooltip, setTooltip] = useState<TruncatedTooltipState | null>(null);

  const showTooltip = useCallback((event: TruncatedTooltipEvent, text: string) => {
    const trigger = event.currentTarget;
    const target = targetSelector
      ? trigger.querySelector<HTMLElement>(targetSelector)
      : trigger;

    if (!target) {
      setTooltip(null);
      return;
    }

    const isTruncated = target.scrollWidth > target.clientWidth;
    if (!isTruncated) {
      setTooltip(null);
      return;
    }

    const rect = target.getBoundingClientRect();
    setTooltip({
      text,
      top: rect.top,
      left: rect.left,
    });
  }, [targetSelector]);

  const hideTooltip = useCallback(() => {
    setTooltip(null);
  }, []);

  return {
    tooltip,
    showTooltip,
    hideTooltip,
  };
};